import { combineReducers } from 'redux';
import { routerReducer } from 'react-router-redux'
import {auth, loadingLoginFailed, login, loginIsLoading} from "../login/LoginReducer";
import {
    days, daysLoading, extendOrPayout, initialOrder, loadingDaysFailed, monthlyTotal,
    openDays, invites, userOnTrack, betMode, showInviteFriends, offerPayout, retry, nextPayout, period, periodBegin,
    successfulMonths, postId, link, ad, newVersion
} from "../overview/OverviewReducer";
import {loadingWorkoutFailed, workout, workoutAlreadyMissed, workoutLoading} from "../workout/WorkoutReducer";
import {levelLoading, levelSet, loadingLevelFailed} from "../level/LevelReducer";
import {loadingSubmitFailed, submitAlreadyMissed, submitLoading} from "../workout/SubmitReducer";
import {declinePayoutLoading, declinePayoutSuccess, loadingDeclinePayoutFailed} from "../payout/DeclinePayoutReducer";
import {loadingRetryFailed, retryLoading, retrySuccess} from "../retry/RetryReducer";
import {loadingRequestPayoutFailed, requestPayoutLoading, requestPayoutSuccess} from "../payout/RequestPayoutReducer";
import {loadingPauseFailed, pauseLoading, pauseSuccess} from "../pause/PauseReducer";
import {feedbackLoading, feedbackSet, loadingFeedbackFailed} from "../rating/FeedbackReducer";
import {loadingReorderFailed, reorderLoading} from "../reorder/ReorderReducer";
import {reorderCorrupted} from "../reorder/ReorderReducer";

export default combineReducers({
    //login
    auth,
    login,
    loadingLoginFailed,
    loginIsLoading,
    //overview
    days,
    loadingDaysFailed,
    daysLoading,
    //profile infos
    monthlyTotal,
    openDays,
    initialOrder,
    invites,
    userOnTrack,
    betMode,
    postId,
    link,
    ad,
    showInviteFriends,
    offerPayout,
    newVersion,
    retry,
    nextPayout,
    periodBegin,
    successfulMonths,
    period,
    //workout
    workout,
    loadingWorkoutFailed,
    workoutLoading,
    workoutAlreadyMissed,
    loadingReorderFailed,
    reorderLoading,
    reorderCorrupted,
    //submit
    loadingSubmitFailed,
    submitLoading,
    submitAlreadyMissed,
    //level
    levelSet,
    loadingLevelFailed,
    levelLoading,
    //feedback
    feedbackSet,
    loadingFeedbackFailed,
    feedbackLoading,
    //payout
    extendOrPayout,
    //payout
    loadingDeclinePayoutFailed,
    declinePayoutLoading,
    declinePayoutSuccess,
    //retry
    loadingRetryFailed,
    retryLoading,
    retrySuccess,
    //payout
    loadingRequestPayoutFailed,
    requestPayoutLoading,
    requestPayoutSuccess,
    //pause
    loadingPauseFailed,
    pauseLoading,
    pauseSuccess,
    routing: routerReducer
});



// WEBPACK FOOTER //
// ./src/reducers/index.js